let mobx = require('mobx');
// create State object
let data = {
    is_never_show_welcome: false,
}
let cancelOrderState = mobx.observable(data);

// export default loginState;
module.exports = cancelOrderState;